import Spin from 'antd/lib/spin/index'
import 'antd/lib/spin/style/index.less'

export default Spin
